// extracted by mini-css-extract-plugin
export var attachmentContainer = "_l7-0";
export var fileList = "_l7-2";
export var removeFileButton = "_l7-1";